
import Card from 'vux/src/components/card/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import CourseCard from './CourseCard'
import _ from 'lodash'
import backend from '@/modules/Backend'
import dateUtils from '@/modules/dateUtils'

export default {
  components: { Card, Divider, Group, Cell, CellFormPreview, XHeader, InlineLoading, CourseCard },
  data () {
    return {
      courseInstanceId: this.$route.params.id,
      courseInstance: {},
      scores: [],
      statistic: [],
      showHomework: false,
      showParticipation: false,
      loaded: false
    }
  },
  methods: {
    formatDate (date) {
      return dateUtils.format(date)
    },

    async loadData () {
      this.courseInstance = (await backend.fetchCourseInstances({
        studentId: 'me',
        courseInstanceId: [this.courseInstanceId]
      }))[0]

      this.statistic = await backend.fetchStatistics('me', this.courseInstanceId)

      this.scores = await backend.fetchScores('me', this.courseInstanceId)
    }
  },

  computed: {

    homeworkList () {
      return this.$store.state.todoHomeworks
        .filter(hw => hw.course_instance_id + '' === this.courseInstanceId)
        .map(hw => ({ label: this.formatDate(hw.due_date) + ' ' + hw.title, value: '' }))
    },

    participationList () {
      let participationInWeeks = this.statistic.participation_in_week || []
      let participations = _.map(['周一', '周二', '周三', '周四', '周五'], (label, index) => {
        return {label: label, value: participationInWeeks[index] || '-'}
      })

      participations.push({
        label: '老师评语',
        value: this.statistic.comments || '-'
      })

      return participations
    },

    scoreList () {
      return this.scores.length > 0 ? this.scores[0].composition : []
    }
  },

  created () {
    this.$store.dispatch('load', ['todoHomeworks'])
  },

  async mounted () {
    await this.loadData()
    this.loaded = true
  }
}



// WEBPACK FOOTER //
// ./src/components/CourseInstance.vue